import { initialAmpelSystemState } from "../mealyModels/AmpelSystem/ampelSystemState";
import { initialDoorSystemState } from "../mealyModels/DoorSystem/doorSystemState";
import { initialGaragentorSystemState } from "../mealyModels/Garagentor/garagentorSystemState";
import { MealyModelType } from "../mealyModels/mealyModelType";
import { initialExecutionStateDEA, initialExecutionStateMealy } from "./executionState";
import { initialMachineDEA, initialMachineMealy } from "./machine";
import { initialPopUpMessage } from "./popUpMessage";
import { initialUiProgramStateDEA, initialUiProgramStateMealy } from "./uiState";
export const initialAnimationState = {
    startTimestamp: 0,
    progress: 0,
    fromStateId: "0",
    toStateId: "0",
    transitionId: "0",
    char: "",
    charIndex: -1,
};
export const initialMachineStateMealy = {
    type: 'MachineStateMealy',
    uiState: initialUiProgramStateMealy,
    machine: initialMachineMealy,
    mealyModelType: MealyModelType.AMPELSYSTEM,
    executionState: initialExecutionStateMealy,
    errors: [],
    popUpMessage: initialPopUpMessage,
    ampelSystemState: initialAmpelSystemState,
    animation: initialAnimationState,
};
export const initialMachineStateAmpelSystem = {
    type: 'MachineStateMealy',
    uiState: initialUiProgramStateMealy,
    machine: initialMachineMealy,
    mealyModelType: MealyModelType.AMPELSYSTEM,
    executionState: initialExecutionStateMealy,
    errors: [],
    popUpMessage: initialPopUpMessage,
    ampelSystemState: initialAmpelSystemState,
    animation: initialAnimationState,
};
export const initialMachineStateCodeschloss = {
    type: 'MachineStateMealy',
    uiState: initialUiProgramStateMealy,
    machine: initialMachineMealy,
    mealyModelType: MealyModelType.CODESCHLOSS,
    executionState: initialExecutionStateMealy,
    errors: [],
    popUpMessage: initialPopUpMessage,
    animation: initialAnimationState,
};
export const initialMachineStateGaragentor = {
    type: 'MachineStateMealy',
    uiState: initialUiProgramStateMealy,
    machine: initialMachineMealy,
    mealyModelType: MealyModelType.GARAGENTOR,
    executionState: initialExecutionStateMealy,
    errors: [],
    popUpMessage: initialPopUpMessage,
    garagentorSystemState: initialGaragentorSystemState,
    animation: initialAnimationState,
};
export const initialMachineStateKunstautomat1 = {
    type: 'MachineStateMealy',
    uiState: initialUiProgramStateMealy,
    machine: initialMachineMealy,
    mealyModelType: MealyModelType.KUNSTAUTOMAT1,
    executionState: initialExecutionStateMealy,
    errors: [],
    popUpMessage: initialPopUpMessage,
    animation: initialAnimationState,
};
export const initialMachineStateKunstautomat2 = {
    type: 'MachineStateMealy',
    uiState: initialUiProgramStateMealy,
    machine: initialMachineMealy,
    mealyModelType: MealyModelType.KUNSTAUTOMAT2,
    executionState: initialExecutionStateMealy,
    errors: [],
    popUpMessage: initialPopUpMessage,
    animation: initialAnimationState,
};
export const initialMachineStateDoorSystem = {
    type: 'MachineStateMealy',
    uiState: initialUiProgramStateMealy,
    machine: initialMachineMealy,
    mealyModelType: MealyModelType.DOORSYSTEM,
    executionState: initialExecutionStateMealy,
    errors: [],
    popUpMessage: initialPopUpMessage,
    animation: initialAnimationState,
    doorSystemState: initialDoorSystemState,
};
export const initialMachineStateDEA = {
    type: 'MachineStateDEA',
    uiState: initialUiProgramStateDEA,
    machine: initialMachineDEA,
    executionState: initialExecutionStateDEA,
    popUpMessage: initialPopUpMessage,
    animation: undefined,
};
